module.exports = __webpack_public_path__ + "img/chat_live_on.1634d04.png";